<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 4.875c1.035 0 1.875.84 1.875 1.875a1.88 1.88 0 0 1-.623 1.387l2.723 2.723c.735-1.395 1.275-2.85 1.275-4.11a5.246 5.246 0 0 0-9.03-3.638l2.393 2.393c.344-.39.832-.63 1.387-.63Zm3.277 7.2L8.806 8.602l-.082-.082-6.27-6.27-.953.953 2.385 2.385A5.416 5.416 0 0 0 3.75 6.75C3.75 10.688 9 16.5 9 16.5s1.252-1.387 2.535-3.262l2.512 2.512.953-.953-2.723-2.722Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
